export default function getRecommendedFlex({ weight, height, flexMap }) {
  let flex = 0;
  if (weight <= 55 && weight >= 40) {
    weight = 55;
  } else if (weight <= 65 && weight >= 60) {
    weight = 65;
  } else if (weight <= 80 && weight >= 70) {
    weight = 80;
  } else if (weight <= 90 && weight >= 85) {
    weight = 90;
  } else if (weight <= 105 && weight >= 95) {
    weight = 105;
  } else if (weight >= 295) {
    weight = 300;
  }
  let flexAr = flexMap[weight][0].flex;

  for (let j = 0; j <= flexAr.length - 1; j++) {
    let heightArray = Object.values(Object.values(flexAr)[j])[0];
    let minHeight = heightArray[0];
    let maxHeight = heightArray[1];
    if (height <= maxHeight && height >= minHeight) {
      flex = Object.keys(flexAr[j])[0];
    }
  }
  return flex;
}
